// Vendor Libs
import React, {useContext, useRef} from 'react';
import PropTypes from 'prop-types';

// Material UI
import {Button, Drawer} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

// Contexts
import {LayoutContext} from '../../../contexts/layout-context';

const useStyles = makeStyles(theme => ({
  root: {},
  container: {
    overflow: 'hidden',
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    transition: theme.transitions.create(['width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  content: {
    flexGrow: 1,
    overflow: 'auto',
  },
  collapseButton: {
    backgroundColor: theme.palette.grey[50],
    textAlign: 'center',
    borderRadius: 0,
    borderTop: '1px solid',
    borderColor: 'rgba(0,0,0,0.12)',
    [theme.breakpoints.up('sm')]: {
      minHeight: 40,
    },
  },
  closeButton: {
    position: 'absolute',
    bottom: theme.spacing(2),
    zIndex: theme.zIndex.modal + 1,
    background: theme.palette.common.white,
    boxShadow: theme.shadows[2],
    '@media (hover: none)': {
      backgroundColor: theme.palette.grey[300],
    },
    '&:hover': {
      backgroundColor: '#e5e5e5',
    },
  },
}));

const Nav = ({className, header, children, collapsedIcon}) => {
  const layoutContext = useContext(LayoutContext);
  const classes = useStyles();
  const {
    open,
    setOpen,
    navVariant,
    navAnchor,
    navWidth,
    collapsedWidth,
    collapsible,
    collapsed,
    setCollapsed,
  } = layoutContext;
  const width = collapsible && collapsed ? collapsedWidth : navWidth;
  const shouldRenderButton = collapsible && collapsedIcon;
  const contentRef = useRef(null);

  return (
    <>
      <Drawer
        anchor={navAnchor}
        className={`${className} ${classes.root}`}
        open={open}
        variant={navVariant}
        onClose={() => setOpen(!open)}
      >
        <div className={classes.container} style={{width}}>
          {typeof header === 'function' ? header(layoutContext) : header}
          <div className={classes.content} ref={contentRef}>
            {typeof children === 'function' ? children(layoutContext) : children}
          </div>
          {shouldRenderButton && (
            <Button className={classes.collapseButton} fullWidth={true} onClick={() => setCollapsed(!collapsed)}>
              {collapsed ? collapsedIcon.active : collapsedIcon.inactive || collapsedIcon.active}
            </Button>
          )}
        </div>
      </Drawer>
    </>
  );
};

Nav.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  className: PropTypes.string,
  collapsedIcon: PropTypes.shape({
    active: PropTypes.node,
    inactive: PropTypes.node.isRequired,
  }),
  header: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

Nav.defaultProps = {
  className: '',
  header: null,
  collapsedIcon: null,
};

export default Nav;
